import {
  ATTENDEESMESSAGING_SENTMSG,
  ATTENDEESMESSAGING_COMMUNICATION,
  ATTENDEESMESSAGING_RECEMSG,
  ATTENDEESMESSAGING_MSGTHREAD,
  ATTENDEESMESSAGING_ITEM_SELECTED,
} from "AttendeesmessagingActions";

import { ATTENDEESNETWORK_MSGSENT } from "AttendeesnetworkActions";

export var AttendeesMessagingMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: ATTENDEESNETWORK_MSGSENT,
      iconName: "msgsent",
      sectionName: "Message Sent",
      sectionDesc: "How many messages are sent in the App",
      selected: false,
    },
    {
      key: ATTENDEESMESSAGING_SENTMSG,
      iconName: "sentmsg",
      sectionName: "Chat Initiator",
      sectionDesc: "Unique no. of attendees who sent at least one message",
      selected: false,
    },
    {
      key: ATTENDEESMESSAGING_COMMUNICATION,
      iconName: "communication",
      sectionName: "Attendee Communication",
      sectionDesc: "Attendees who sent and received at least one message",
      selected: false,
    },
    {
      key: ATTENDEESMESSAGING_RECEMSG,
      iconName: "receivemsg",
      sectionName: "Chat Receiver",
      sectionDesc: "Unique no. of attendees who received at least one message",
      selected: false,
    },
    {
      key: ATTENDEESMESSAGING_MSGTHREAD,
      iconName: "msgthread",
      sectionName: "Attendee Message Threads",
      sectionDesc: "Unique conversations between attendees",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;
  return state;
};

// Initial select tab is "ATTENDEESMESSAGING_SENTMSG"
export var AttendeesmessagingSelectedItem = (
  state = ATTENDEESMESSAGING_SENTMSG,
  action
) => {
  if (action.type == ATTENDEESMESSAGING_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};
